import React, { memo } from 'react';
import styles from './ResizeHandle.module.css';
import { cn } from '../../utils';
import { useT } from '../../i18n';

export interface ResizeHandleProps {
  /** Resize direction: n (north), w (west), e (east), nw/ne (top corners) */
  direction: 'n' | 'w' | 'e' | 'nw' | 'ne';
  onMouseDown: (e: React.MouseEvent, direction: string) => void;
}

/**
 * Drag-to-resize handle. No south edge, since the widget is anchored to the
 * bottom, and the pinned side has none.
 */
export const ResizeHandle = memo(function ResizeHandle({
  direction,
  onMouseDown,
}: ResizeHandleProps) {
  const t = useT();
  const isCorner = direction === 'nw' || direction === 'ne';
  const isHorizontal = direction === 'n';
  const isVertical = direction === 'w' || direction === 'e';

  return (
    <div
      className={cn(
        styles.handle,
        isCorner && styles.corner,
        isHorizontal && styles.horizontal,
        isVertical && styles.vertical,
        styles[direction],
      )}
      onMouseDown={(e) => onMouseDown(e, direction)}
      role="separator"
      aria-orientation={isHorizontal ? 'horizontal' : 'vertical'}
      aria-label={t('common.resizeHandle', { direction })}
    />
  );
});
